/**
 * Helpers for the /applications/kick_notif/ response.
 *
 * The API returns:  [ [ [title, message, date, isRead], ... ], unreadCount ]
 * These helpers turn that positional array into plain objects so the
 * header panel and the Notifications page stay in sync.
 */
import { formatDate } from "./dateFormatter";

const ISO_LIKE = /^\d{4}-\d{2}-\d{2}/;

export function normalizeNotification(row) {
  const r = Array.isArray(row) ? row : [];
  const rawDate = r[2] == null ? "" : String(r[2]);
  return {
    title: r[0] || "Notification",
    message: r[1] || "",
    // only reformat real timestamps; keep text such as "2 hours ago" as is
    date: ISO_LIKE.test(rawDate) ? formatDate(rawDate) : rawDate,
    unread: !r[3],
  };
}

export function parseNotificationResponse(data) {
  if (!Array.isArray(data)) return { items: [], count: 0 };
  return {
    items: Array.isArray(data[0]) ? data[0].map(normalizeNotification) : [],
    count: Number(data[1]) || 0,
  };
}

export default { normalizeNotification, parseNotificationResponse };